import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { isAuthenticated } from './firebase/firebase';
import InstagramAuth from 'pages/instagramAuth/instagramAuth';
import InstagramLogin from 'pages/instagramLogin/instagramLogin';
import UserDetails from 'pages/userDetails/userDetails';
import Profile from 'pages/profile/profile';

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route {...rest} render={props => (
    isAuthenticated() ? <Component {...props} /> : <Redirect to="/" />
  )} />
);

const getRoutes = () => (
  <Switch>
    <Route exact path="/" component={InstagramLogin} />
    <Route path="/instagram" component={InstagramAuth} />
    <PrivateRoute path="/details" component={UserDetails} />
    <Route path="/:username" component={Profile} />
    <Redirect to="/" />
  </Switch>
);

export default getRoutes;



// WEBPACK FOOTER //
// ./src/routes.js